import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en/translations.json";
import frTranslations from "./locales/fr/translations.json";
import esTranslations from "./locales/es/translations.json";
import deTranslations from "./locales/de/translations.json";
import itTranslations from "./locales/it/translations.json";
import ptTranslations from "./locales/pt/translations.json";
import hiTranslations from "./locales/hi/translations.json";
import zhTranslations from "./locales/zh/translations.json";

i18n
  // Detect user language
  // Learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  // Learn more: https://www.i18next.com/overview/configuration-options
  .init({
    // Default language
    fallbackLng: "en",

    // Languages to support
    supportedLngs: ["en", "fr", "es", "de", "it", "pt", "hi", "zh"], // Add more languages here: ['en', 'es', 'fr']

    // Debug mode (set to false in production)
    debug: process.env.NODE_ENV === "development",

    // Namespace configuration
    defaultNS: "translations",
    ns: ["translations"],

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Translation resources
    resources: {
      en: {
        translations: enTranslations,
      },
      fr: {
        translations: frTranslations,
      },
      es: {
        translations: esTranslations,
      },
      de: {
        translations: deTranslations,
      },
      it: {
        translations: itTranslations,
      },
      pt: {
        translations: ptTranslations,
      },
      hi: {
        translations: hiTranslations,
      },
      zh: {
        translations: zhTranslations,
      },
    },

    // Language detection options
    detection: {
      // Order and from where user language should be detected
      order: ["localStorage", "navigator", "htmlTag"],

      // Keys or params to lookup language from
      lookupLocalStorage: "i18nextLng",

      // Cache user language on
      caches: ["localStorage"],

      // Optional expire and domain for set cookie
      cookieMinutes: 10080, // 7 days
    },
  });

export default i18n;
